import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Testimonial.css";
import Testimonialslider from "./Testimonialslider";
import captra from "./../images/capterra.svg";
import axios  from "axios";
import { Link } from "react-router-dom";


const Testimonial = () => {
  const [firstName, setFirstName] = useState("");
  const [mobile, setMobile] = useState("");
  const [company, setCompanyname] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [noOfVendors, setNoOfVendors] = useState("someOption"); // Default value
  const [requirements, setRequirements] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState(
    Math.floor(Math.random() * 10) + 1
  ); 
  const navigate = useNavigate(); 
  const validateForm = () => {
    const errors = {};

    if (!firstName) {
      errors.firstName = "First name is required";
    }

    if (!mobile) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d+$/i.test(mobile)) {
      errors.mobile = "Invalid mobile number format";
    }
    if (!company) {
      errors.company = "Company name is required";
    }

    if (!email) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/i.test(email)) {
      errors.email = "Invalid email format";
    }

    if (!city) {
      errors.city = "City is required";
    }

    if (noOfVendors === "someOption") {
      errors.noOfVendors = "Please select the number of vendors";
    }

    // if (captchaValue !== String(captchaAnswer)) {
    //   errors.captcha = "Incorrect answer to the CAPTCHA";
    // }
    if (!requirements) {
      errors.requirements = "Requirements is required";
    }
    setFormErrors(errors);

    return Object.keys(errors).length === 0; // Form is valid if there are no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (validateForm()) {
      // const url = 'https://www.vendorascmsoftware.com/lp/vendor-management-system/formscript_api.php';
      const data = {
        firstName: firstName,
        mobile: mobile,
        company: company,
        email: email,
        city: city,
        noOfVendors: noOfVendors,
        requirements: requirements,
      };
      
      await axios.post('https://www.vendorascmsoftware.com/lp/vendor-management-system/formscript_api.php', data, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then((response) => {
        if (response && response.data && response.data[0].response) {
          const responseCode = response.data[0].response.response_code;
          console.log('Response Code:', responseCode);

          if (responseCode === '1') {
            // Clear form fields on successful submission
            setFirstName('');
            setMobile('');
            setCompanyname('');
            setEmail('');
            setCity('');
            setNoOfVendors('someOption');
            setRequirements('');
            setCaptchaValue('');
            // Success
          } else {
            // Handle the case when the API returns an error
            console.log('API error:', response.data[0].response.response);
            // Handle the error condition here
          }
        } else {
          // Handle the case when the response structure is unexpected
          console.error('Unexpected response structure');
        }
      })
      .catch((error) => {
        // Handle network or other errors
        console.error('Fetch Error:', error);
      });
      navigate("/ThankYou", { state: { formData: data } });
  } else {
    // The form is invalid, do not submit
    console.log('Form has validation errors');
  }







  };


  return (
    <div className="testimonial" >
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h6>Testimonials</h6>
            <h1>
              What our Client's <br />
              says about us
            </h1>
            <Testimonialslider />
            <div className="captera text-center">
              <Link to="https://www.capterra.com/p/194158/Vendora/" target="_blank"><img src={captra} alt="logog" /></Link>
            </div>
          </div>
          <div className="col-md-6" id="quotes">
            <div className="testimonial-form">
              <form onSubmit={handleSubmit} >
                <div className="row">
                  <h3>
                    <span>Let's </span> Get Started
                  </h3>
                  <div className="col-md-6">
                    <label>Name</label>
                    <input
                      type="text"
                      placeholder="Enter your Name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    {formErrors.firstName && (
                      <div className="error">{formErrors.firstName}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      placeholder="Enter your Number"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                    {formErrors.mobile && (
                      <div className="error">{formErrors.mobile}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label>Company Name</label>
                    <input
                      type="text"
                      placeholder="Enter your Company Name"
                      value={company}
                      onChange={(e) => setCompanyname(e.target.value)}
                    />
                    {formErrors.company && (
                      <div className="error">{formErrors.company}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label>Company Mail Id</label>
                    <input
                      type="text"
                      placeholder="Enter your Mail Id"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {formErrors.email && (
                      <div className="error">{formErrors.email}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label>City</label>
                    <input
                      type="text"
                      placeholder="Enter your City"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                    {formErrors.city && (
                      <div className="error">{formErrors.city}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label>No Of Vendors</label>
                    <select
                      value={noOfVendors}
                      onChange={(e) => setNoOfVendors(e.target.value)}
                    >
                      <option value="someOption">Select No Of vendors</option>
                      <option value="50-100">50-100</option>
                      <option value="100-250">100-250</option>
                      <option value="250-500">250-500</option>
                      <option value="500-1000">500-1000</option>
                      <option value="above 1000">Above 1000</option>
                    </select>
                    {formErrors.noOfVendors && (
                      <div className="error">{formErrors.noOfVendors}</div>
                    )}
                  </div>
                  <div className="col-md-12">
                    <label>Requirements</label>
                    <input
                      type="text"
                      placeholder="requirements"
                      value={requirements}
                      onChange={(e) => setRequirements(e.target.value)}
                    />
                    {formErrors.requirements && (
                      <div className="error">{formErrors.requirements}</div>
                    )}
                  </div>
                  <div className="col-md-12 captcher">
                    <label>Verify Captcha *</label>
                    <div className="captha-form">
                      {captchaAnswer} + 3 ={" "}
                      <input
                        type="text"
                        value={captchaValue}
                        onChange={(e) => setCaptchaValue(e.target.value)}
                      />
                    </div>
                    {formErrors.captcha && (
                      <div className="error">{formErrors.captcha}</div>
                    )}
                  </div>

                  <button type="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
